<template>
    <div class="addTemplatePage">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
            <el-form-item label="合同模板名称" prop="doc_title">
                <el-input v-model="ruleForm.doc_title" placeholder="请输入合同模板名称"></el-input>
            </el-form-item>
            <el-form-item label="模板类型" prop="tpl_type">
                <el-radio-group v-model="ruleForm.tpl_type">
                    <el-radio label="1">表单式</el-radio>
                    <el-radio label="2">预览式</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="模板文件" prop="tpl_type">
                <el-upload
                    ref='upload'
                    class="inline"
                    :limit="1"
                    :on-preview="handlePreview"
                    :on-remove="(file, fileList) => {handleRemove(file, fileList, upload_data.doc_type)}"
                    :on-success="handleSuccess"
                    :on-exceed="handleExceed"
                    accept=".pdf"
                    :headers="headers"
                    :action="url"
                    name="file"
                    :data="upload_data"
                    :file-list="fileList">
                    <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
            </el-form-item>
        </el-form>

        <el-button type="primary" @click="saveBtn" style="display: block;margin: auto">新增模板</el-button>
    </div>
</template>

<script>
    import { addTemplate } from '@/api/template_kh';
    import bus from '@/components/common/bus';

    export default {
        name: 'addTemplatePage',
        data() {
            return {
                url:process.env.VUE_APP_BASE_API+'/api/upload_cont_tpl_file',
                headers:{
                    "Authorization": sessionStorage.getItem("token"),
                    "Comid": sessionStorage.getItem("shenfen"),
                    "Platformsn":JSON.parse(localStorage.getItem('userData')).platform_sn
                },
                upload_data:{},
                fileList:[],
                templateFile:{
                    fileId:'',
                },
                ruleForm:{
                    doc_title:'', //合同模板名称
                    fileId:'',  //文件ID
                    tpl_type:'1',  //模板类型
                },
                rules:{
                    doc_title:[
                        { required: true, message: '请输入合同模板名称', trigger: 'blur' }
                    ],
                    tpl_type:[
                        { required: true, message: '请选择模板类型', trigger: 'blur' }
                    ]
                }
            };
        },
        methods:{
            //点击文件列表事件
            handlePreview(file){
                if (file.all_url){
                    const link = document.createElement("a"); //自己创建的a标签
                    link.href = file.all_url+'?v='+Math.random();
                    link.target="_blank"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(file.all_url);
                }else if (file.response){
                    const link = document.createElement("a"); //自己创建的a标签
                    link.href = file.response.data.all_url+'?v='+Math.random();
                    link.target="_blank"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(file.response.data.all_url);
                }
            },
            // 移除
            handleRemove(){

            },
            //上传成功
            handleSuccess(response, file, fileList){
                if (response.code == 200){
                    this.ruleForm.fileId=response.data.fileId
                }else {
                    this.$message.error(response.msg);
                }
            },
            //限制条数
            handleExceed(files, fileList){
                if (fileList.length>=1){
                    this.$message.error('只能上传1个文件');
                }
            },
            // 新增模板
            saveBtn(){
                this.$refs.ruleForm.validate(valid =>{
                    if (valid){
                        if (this.ruleForm.fileId==''){
                            this.$message.error('请上传文件');
                        }else {
                            addTemplate(this.ruleForm).then(res=>{
                                if (res.code==200){
                                    this.$message.success(res.msg);
                                    bus.$emit('close_current_tags')
                                    this.$router.push({ path:'/signDeploy',query:{tpl_id:res.data.id} })
                                    // this.$router.push({
                                    //     path:'/templateList'
                                    // })
                                }else {
                                    this.$message.error(res.msg);
                                }
                            })
                        }
                    }else {
                        return false
                    }
                })
            }
        },
        created() {
            this.headers.Comid=JSON.parse(sessionStorage.getItem("shenfen")).com_id
        }
    }
</script>

<style scoped lang="scss">
    .addTemplatePage {
        background-color: #ffffff;
        padding: 20px;
        border-radius: 5px;
    }
    .el-input{
        width: 20%;
    }
    ::v-deep .el-upload--text{
        border: 0;
        width: 80px;
        height: 35px;
    }
    ::v-deep .upload-demo{
        display: flex;
    }
    ::v-deep .el-upload-list__item{
        margin-top: 0;
        height: 35px;
        margin-left: 10px;
    }
    ::v-deep .el-upload-list__item-name .el-upload-list__item-status-label{
        height: 35px;
        line-height: 35px;
    }
    .inline{
        display: flex;
    }
</style>